<template>
  <div class="alert">
    <div class="alert__content">
      <div class="alert__content_title">
        {{ alertModel.alertTitle }}
      </div>
      <div class="alert__content_text">
        {{ alertModel.alertText }}
      </div>
    </div>
    <div
      v-if="alertModel.buttonLinkText"
      class="alert__action alert__action_link"
      @click="openLink"
      v-html="alertModel.buttonLinkText"
    ></div>
    <div class="alert__action alert__action_close" @click="onAlertHide">
      <span>
        {{ alertModel.closeButtonText }}
      </span>
    </div>
  </div>
</template>

<script>
import useAlert from "@/composables/useAlert";

export default {
  setup() {
    return useAlert();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

@function px-to-material($target) {
  @return calc($target * 0.96);
}

* {
  &::first-letter {
    text-transform: capitalize;
  }
}

.alert {
  position: absolute;
  width: max-content;
  text-align: left;
  border-radius: px-to-material(2px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: px-to-material(280px);

  font-family: Roboto-Medium;
  background-color: $colorAlertMaterial;

  &__content {
    padding: px-to-material(21px) px-to-material(24px) px-to-material(16px);

    &_title {
      font-size: px-to-material(20px);
      line-height: px-to-material(28px);
    }

    &_text {
      font-family: Roboto-Regular;
      font-size: px-to-material(17px);
      line-height: px-to-material(20px);
      margin-top: px-to-material(12px);
    }
  }

  &__action {
    display: flex;
    align-items: center;
    font-size: px-to-material(14px);
    line-height: px-to-material(17px);
    letter-spacing: px-to-material(0.5px);
    height: px-to-material(48px);
    color: $colorRed;
    text-transform: uppercase;

    &_link {
      text-align: right;
      justify-content: flex-end;
      padding: 0 px-to-material(24px);
    }

    &_close {
      justify-content: flex-end;
      padding: 0 px-to-material(24px);
      margin-bottom: px-to-material(8px);
    }
  }
}
</style>
